export default "__VITE_ASSET__Bx$IBpie__"